// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3qFBF","content":"ManualTimeModal_content__O0Nb-"};